import React from "react";

import WhyChooseSection from "../pages/WhyChooseSection";
import ReviewsSection from "../pages/ReviewsSection";


const AboutSection = () => {


  const stats = [
    {
      number: "50K",
      label: "Happy Customers"
    },

    {
      number: "300",
      label: "Vehicles in Fleet"
    },

    {
      number: "15",
      label: "Years Experience"
    },

  ];




  const features = [

    "Safe & Reliable Travel",

    "Professional Drivers",

    "Customer Satisfaction",

    "Transparent Pricing",

    "24×7 Cab Availability",

    "Quality Service",

  ];






  return (

    <>

 <section className="page-banner">
      <div className="page-banner-container">
        <h2>
          About Us
        </h2>
      </div>
    </section>
   







      <section className="about-section p-0 py-3">


        <div className="about-container">


          <div className="about-grid">





            {/* Stats */}


            <div className="about-stats">


              {
                stats.map((stat,index)=>(


                  <div 
                    className="stat-box"
                    key={index}
                  >


                    <h3>

                      {stat.number}

                      <span>
                        +
                      </span>

                    </h3>



                    <p>
                      {stat.label}
                    </p>


                  </div>


                ))
              }


            </div>







            {/* Content */}



            <div className="about-content">



              <span className="about-small-title">

                Who We Are

              </span>





              <h2>

                Shreesha Tours & Travels provides safe,
                comfortable and reliable cab services for
                every journey.

              </h2>





              <div className="about-inner">



                <div className="about-text">


                  <p>

                    Shreesha Tours & Travels is a trusted travel
                    partner offering airport transfers, local taxi
                    services, outstation cabs, corporate travel,
                    pilgrimage tours and family trips across
                    Maharashtra and India.

                  </p>




                  <p>

                    With a wide range of vehicles including Sedan,
                    Ertiga, SUV, Innova and Innova Crysta, we ensure
                    comfortable journeys with experienced drivers,
                    affordable pricing and 24×7 customer support.

                  </p>





{/* 
                  <a
                    href="/services"
                    className="primary-btn"
                  >

                    View Our Services

                    <i className="ri-arrow-right-line"></i>

                  </a> */}







                  {/* <ul className="feature-list">


                    {
                      features.map((feature,index)=>(


                        <li key={index}>


                          <i className="ri-check-double-line"></i>


                          {feature}


                        </li>


                      ))
                    }


                  </ul> */}






                </div>







                <div className="about-image">


                  <img

                    src="/images/about.png"

                    alt="Shreesha Tours and Travels"

                  />


                </div>





              </div>



            </div>






          </div>


        </div>


      </section>






      <WhyChooseSection />

      <ReviewsSection />



    </>

  );


};


export default AboutSection;